var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirculeAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    rx: 4.5,
    fill: "#46967C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirculeAdmin);
export default __webpack_public_path__ + "static/media/circuleAdmin.08e715806845c7bd31734702de135f64.svg";
export { ForwardRef as ReactComponent };